// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Help-page-M1KRQ {
  --red: #e8232b;
  --red-d: #c2151c;
  --green: #16a34a;
  --green-d: #0f7a37;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.Help-wrap-vpIe2 {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Search */

.Help-searchSec-BHXtt {
  background: #fff;
  padding: 0 0 8px;
}

.Help-searchWrap-BKQIt {
  max-width: 680px;
  margin: -28px auto 0;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.Help-searchBox-rn2uT {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 4px 18px;
  -webkit-box-shadow: 0 16px 40px rgba(15, 18, 20, 0.1);
          box-shadow: 0 16px 40px rgba(15, 18, 20, 0.1);
}

.Help-searchIcon-gxfwk {
  width: 22px;
  height: 22px;
  color: var(--muted);
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.Help-searchInput-ENiVG {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 16px;
  font-family: inherit;
  color: var(--ink);
  min-height: 52px;
}

.Help-searchInput-ENiVG::-webkit-input-placeholder {
  color: var(--muted);
}

.Help-searchInput-ENiVG::-moz-placeholder {
  color: var(--muted);
}

.Help-searchInput-ENiVG:-ms-input-placeholder {
  color: var(--muted);
}

.Help-searchInput-ENiVG::-ms-input-placeholder {
  color: var(--muted);
}

.Help-searchInput-ENiVG::placeholder {
  color: var(--muted);
}

/* Topic tiles */

.Help-tilesSec-ap444 {
  padding: 36px 0 8px;
}

.Help-tiles-wSqUH {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.Help-tile-SWqFp {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 16px 18px;
  background: #fff;
  text-decoration: none;
  color: var(--ink);
  -webkit-transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, border-color 0.16s, box-shadow 0.16s;
  transition: transform 0.16s, border-color 0.16s, box-shadow 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.Help-tile-SWqFp:hover {
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  border-color: #f3c9cb;
  -webkit-box-shadow: 0 12px 28px rgba(15, 18, 20, 0.07);
          box-shadow: 0 12px 28px rgba(15, 18, 20, 0.07);
}

.Help-tileIc-CjUCO {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.Help-tileIc-CjUCO svg {
  width: 22px;
  height: 22px;
}

.Help-tileName-Kfku5 {
  font-size: 15px;
  font-weight: 700;
}

/* Articles */

.Help-articlesSec-_TMTx {
  padding: 40px 0 8px;
}

.Help-group-KSghN {
  margin-bottom: 36px;
  scroll-margin-top: 90px;
}

.Help-groupTitle-pQbRl {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  font-size: clamp(20px, 3vw, 26px);
  font-weight: 800;
  margin: 0 0 18px;
}

.Help-groupIc-fVIW8 {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #e4f6f3;
  color: var(--green);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.Help-groupIc-fVIW8 svg {
  width: 20px;
  height: 20px;
}

.Help-qaList-fLRMh {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
}

.Help-qa-RVE1N {
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
}

.Help-qaQ-RlOOl {
  list-style: none;
  cursor: pointer;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  min-height: 44px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.Help-qaQ-RlOOl::-webkit-details-marker {
  display: none;
}

.Help-qaQ-RlOOl::after {
  content: '+';
  font-size: 22px;
  font-weight: 600;
  color: var(--muted);
  line-height: 1;
}

.Help-qa-RVE1N[open] .Help-qaQ-RlOOl::after {
  content: '–';
}

.Help-qaQ-RlOOl:hover {
  color: var(--red);
}

.Help-qaA-DT7dv {
  margin: 0;
  padding: 0 20px 18px;
  font-size: 15px;
  line-height: 1.6;
  color: var(--muted);
}

.Help-noResults-t_5yS {
  font-size: 16px;
  color: var(--muted);
  text-align: center;
  padding: 24px 0;
}

.Help-inlineLink-g614f,
.Help-relLink-irN39 {
  color: var(--red);
  font-weight: 700;
  text-decoration: none;
}

.Help-inlineLink-g614f:hover,
.Help-relLink-irN39:hover {
  text-decoration: underline;
}

.Help-related-mMU8X {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px 18px;
  padding: 18px 0 0;
  font-size: 14px;
  color: var(--muted);
  border-top: 1px solid var(--line);
}

/* Contact */

.Help-contactSec-z52WE {
  padding: 48px 0;
}

.Help-contactCard-N7IKT {
  text-align: center;
  border: 1px solid var(--line);
  border-radius: 22px;
  padding: 40px 28px;
  background: #e4f6f3;
}

.Help-contactTitle-a1J6P {
  font-size: clamp(22px, 3.4vw, 30px);
  font-weight: 800;
  margin: 0 0 8px;
}

.Help-contactText-ssaBH {
  font-size: 16px;
  color: var(--muted);
  margin: 0 0 22px;
}

.Help-contactActions-ADvIq {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.Help-contactBtn-Tz1rF,
.Help-contactBtnAlt-bSZ8_ {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 48px;
  padding: 13px 26px;
  border-radius: 14px;
  font-weight: 700;
  font-size: 15px;
  text-decoration: none;
  -webkit-transition: background 0.16s, border-color 0.16s, -webkit-transform 0.16s;
  transition: background 0.16s, border-color 0.16s, -webkit-transform 0.16s;
  transition: transform 0.16s, background 0.16s, border-color 0.16s;
  transition: transform 0.16s, background 0.16s, border-color 0.16s, -webkit-transform 0.16s;
}

.Help-contactBtn-Tz1rF {
  background: var(--green);
  color: #fff;
}

.Help-contactBtn-Tz1rF:hover {
  background: var(--green-d);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

.Help-contactBtnAlt-bSZ8_ {
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
}

.Help-contactBtnAlt-bSZ8_:hover {
  border-color: #bfe6d3;
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
}

@media (max-width: 760px) {
  .Help-tiles-wSqUH {
    grid-template-columns: 1fr;
  }
}

@media (prefers-color-scheme: dark) {
  .Help-page-M1KRQ,
  .Help-searchSec-BHXtt {
    background: #14171a;
    color: #f3f4f6;
  }
  .Help-groupTitle-pQbRl,
  .Help-tileName-Kfku5,
  .Help-qaQ-RlOOl,
  .Help-contactTitle-a1J6P {
    color: #f3f4f6;
  }
  .Help-qaA-DT7dv,
  .Help-contactText-ssaBH,
  .Help-related-mMU8X,
  .Help-noResults-t_5yS {
    color: #9aa3ad;
  }
  .Help-searchBox-rn2uT,
  .Help-tile-SWqFp,
  .Help-qa-RVE1N {
    background: #1d2125;
    border-color: #2c3137;
  }
  .Help-searchInput-ENiVG {
    color: #f3f4f6;
  }
  .Help-tileIc-CjUCO {
    background: rgba(232, 35, 43, 0.14);
  }
  .Help-groupIc-fVIW8 {
    background: rgba(22, 163, 74, 0.16);
  }
  .Help-contactCard-N7IKT {
    background: rgba(22, 163, 74, 0.12);
    border-color: #2c3137;
  }
  .Help-contactBtnAlt-bSZ8_ {
    background: #1d2125;
    color: #f3f4f6;
    border-color: #2c3137;
  }
  .Help-related-mMU8X {
    border-top-color: #2c3137;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/help/Help.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;;AACX;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,qDAA6C;UAA7C,6CAA6C;AAC/C;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AACA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAFA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;;AAChB;EACE,mBAAmB;AACrB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,yFAAiE;EAAjE,iFAAiE;EAAjE,iEAAiE;EAAjE,oHAAiE;AACnE;;AACA;EACE,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;EACrB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;;AACb;EACE,mBAAmB;AACrB;;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AACA;EACE,aAAa;AACf;;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AACA;EACE,YAAY;AACd;;AACA;EACE,iBAAiB;AACnB;;AACA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AACA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,YAAY;;AACZ;EACE,eAAe;AACjB;;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAe;MAAf,eAAe;AACjB;;AACA;;EAEE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iFAAiE;EAAjE,yEAAiE;EAAjE,iEAAiE;EAAjE,0FAAiE;AACnE;;AACA;EACE,wBAAwB;EACxB,WAAW;AACb;;AACA;EACE,0BAA0B;EAC1B,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AACA;EACE,qBAAqB;EACrB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,mBAAmB;IACnB,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;;;;IAIE,cAAc;EAChB;EACA;;;IAGE,mBAAmB;IACnB,qBAAqB;EACvB;EACA;IACE,cAAc;EAChB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;IACnC,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --green: #16a34a;\n  --green-d: #0f7a37;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* Search */\n.searchSec {\n  background: #fff;\n  padding: 0 0 8px;\n}\n.searchWrap {\n  max-width: 680px;\n  margin: -28px auto 0;\n  padding: 0 24px;\n  position: relative;\n  z-index: 2;\n}\n.searchBox {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  padding: 4px 18px;\n  box-shadow: 0 16px 40px rgba(15, 18, 20, 0.1);\n}\n.searchIcon {\n  width: 22px;\n  height: 22px;\n  color: var(--muted);\n  flex: 0 0 auto;\n}\n.searchInput {\n  flex: 1 1 auto;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-size: 16px;\n  font-family: inherit;\n  color: var(--ink);\n  min-height: 52px;\n}\n.searchInput::placeholder {\n  color: var(--muted);\n}\n\n/* Topic tiles */\n.tilesSec {\n  padding: 36px 0 8px;\n}\n.tiles {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n.tile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 16px 18px;\n  background: #fff;\n  text-decoration: none;\n  color: var(--ink);\n  transition: transform 0.16s, border-color 0.16s, box-shadow 0.16s;\n}\n.tile:hover {\n  transform: translateY(-2px);\n  border-color: #f3c9cb;\n  box-shadow: 0 12px 28px rgba(15, 18, 20, 0.07);\n}\n.tileIc {\n  flex: 0 0 auto;\n  width: 42px;\n  height: 42px;\n  border-radius: 11px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.tileIc svg {\n  width: 22px;\n  height: 22px;\n}\n.tileName {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n/* Articles */\n.articlesSec {\n  padding: 40px 0 8px;\n}\n.group {\n  margin-bottom: 36px;\n  scroll-margin-top: 90px;\n}\n.groupTitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: clamp(20px, 3vw, 26px);\n  font-weight: 800;\n  margin: 0 0 18px;\n}\n.groupIc {\n  flex: 0 0 auto;\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  background: #e4f6f3;\n  color: var(--green);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.groupIc svg {\n  width: 20px;\n  height: 20px;\n}\n\n.qaList {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.qa {\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  background: #fff;\n  overflow: hidden;\n}\n.qaQ {\n  list-style: none;\n  cursor: pointer;\n  padding: 16px 20px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--ink);\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.qaQ::-webkit-details-marker {\n  display: none;\n}\n.qaQ::after {\n  content: '+';\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--muted);\n  line-height: 1;\n}\n.qa[open] .qaQ::after {\n  content: '–';\n}\n.qaQ:hover {\n  color: var(--red);\n}\n.qaA {\n  margin: 0;\n  padding: 0 20px 18px;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--muted);\n}\n\n.noResults {\n  font-size: 16px;\n  color: var(--muted);\n  text-align: center;\n  padding: 24px 0;\n}\n.inlineLink,\n.relLink {\n  color: var(--red);\n  font-weight: 700;\n  text-decoration: none;\n}\n.inlineLink:hover,\n.relLink:hover {\n  text-decoration: underline;\n}\n\n.related {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 18px;\n  padding: 18px 0 0;\n  font-size: 14px;\n  color: var(--muted);\n  border-top: 1px solid var(--line);\n}\n\n/* Contact */\n.contactSec {\n  padding: 48px 0;\n}\n.contactCard {\n  text-align: center;\n  border: 1px solid var(--line);\n  border-radius: 22px;\n  padding: 40px 28px;\n  background: #e4f6f3;\n}\n.contactTitle {\n  font-size: clamp(22px, 3.4vw, 30px);\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.contactText {\n  font-size: 16px;\n  color: var(--muted);\n  margin: 0 0 22px;\n}\n.contactActions {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.contactBtn,\n.contactBtnAlt {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 13px 26px;\n  border-radius: 14px;\n  font-weight: 700;\n  font-size: 15px;\n  text-decoration: none;\n  transition: transform 0.16s, background 0.16s, border-color 0.16s;\n}\n.contactBtn {\n  background: var(--green);\n  color: #fff;\n}\n.contactBtn:hover {\n  background: var(--green-d);\n  transform: translateY(-2px);\n}\n.contactBtnAlt {\n  background: #fff;\n  color: var(--ink);\n  border: 1px solid var(--line);\n}\n.contactBtnAlt:hover {\n  border-color: #bfe6d3;\n  transform: translateY(-2px);\n}\n\n@media (max-width: 760px) {\n  .tiles {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .page,\n  .searchSec {\n    background: #14171a;\n    color: #f3f4f6;\n  }\n  .groupTitle,\n  .tileName,\n  .qaQ,\n  .contactTitle {\n    color: #f3f4f6;\n  }\n  .qaA,\n  .contactText,\n  .related,\n  .noResults {\n    color: #9aa3ad;\n  }\n  .searchBox,\n  .tile,\n  .qa {\n    background: #1d2125;\n    border-color: #2c3137;\n  }\n  .searchInput {\n    color: #f3f4f6;\n  }\n  .tileIc {\n    background: rgba(232, 35, 43, 0.14);\n  }\n  .groupIc {\n    background: rgba(22, 163, 74, 0.16);\n  }\n  .contactCard {\n    background: rgba(22, 163, 74, 0.12);\n    border-color: #2c3137;\n  }\n  .contactBtnAlt {\n    background: #1d2125;\n    color: #f3f4f6;\n    border-color: #2c3137;\n  }\n  .related {\n    border-top-color: #2c3137;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Help-page-M1KRQ`,
	"wrap": `Help-wrap-vpIe2`,
	"searchSec": `Help-searchSec-BHXtt`,
	"searchWrap": `Help-searchWrap-BKQIt`,
	"searchBox": `Help-searchBox-rn2uT`,
	"searchIcon": `Help-searchIcon-gxfwk`,
	"searchInput": `Help-searchInput-ENiVG`,
	"tilesSec": `Help-tilesSec-ap444`,
	"tiles": `Help-tiles-wSqUH`,
	"tile": `Help-tile-SWqFp`,
	"tileIc": `Help-tileIc-CjUCO`,
	"tileName": `Help-tileName-Kfku5`,
	"articlesSec": `Help-articlesSec-_TMTx`,
	"group": `Help-group-KSghN`,
	"groupTitle": `Help-groupTitle-pQbRl`,
	"groupIc": `Help-groupIc-fVIW8`,
	"qaList": `Help-qaList-fLRMh`,
	"qa": `Help-qa-RVE1N`,
	"qaQ": `Help-qaQ-RlOOl`,
	"qaA": `Help-qaA-DT7dv`,
	"noResults": `Help-noResults-t_5yS`,
	"inlineLink": `Help-inlineLink-g614f`,
	"relLink": `Help-relLink-irN39`,
	"related": `Help-related-mMU8X`,
	"contactSec": `Help-contactSec-z52WE`,
	"contactCard": `Help-contactCard-N7IKT`,
	"contactTitle": `Help-contactTitle-a1J6P`,
	"contactText": `Help-contactText-ssaBH`,
	"contactActions": `Help-contactActions-ADvIq`,
	"contactBtn": `Help-contactBtn-Tz1rF`,
	"contactBtnAlt": `Help-contactBtnAlt-bSZ8_`
};
module.exports = ___CSS_LOADER_EXPORT___;
